import {Injectable} from '@angular/core';
import { DealTypeEnum } from '../../components/search-filter/model/deal-type.enum';
import { AttributeIcon, ProductAttribute } from '../../models/attributes.model';
import { LocationDTO, ProductCard } from '../../models/product-card.model';
import { ProductTypeEnum } from '../../models/product-type.enum';
import { Slug } from '../slug/slug.service';

@Injectable({
  providedIn: 'root'
})
export class ProductUrlService {

  mapProductUrl(productCard: ProductCard, pathname: string): string {
    if (pathname) {
      return this.mapForCampaign(productCard, pathname);
    } else if (productCard.productType === ProductTypeEnum.RealEstateParent) {
      return this.mapForBrandNewProduct(productCard);
    }
    return this.mapForOwnedProduct(productCard);
  }

  private mapForCampaign(productCard: ProductCard, pathname: string) {
    return `${pathname + productCard.sku}`;
  }

  private mapForBrandNewProduct(productCard: ProductCard) {
    let path = `${this.mapCondominiumName(productCard.name)}-${this.mapAddress(productCard.locationDTO)}`;
    path = Slug.of(path);
    return `/lancamento/${productCard.sku}/${path}`;
  }

  private mapForOwnedProduct(productCard: ProductCard) {
    let path = `${this.mapDealType(productCard)}-` +
      `${productCard.divisionUnitType}-${this.mapProductCharacteristics(productCard.attributes)}` +
      `${this.mapAddress(productCard.locationDTO)}`;
    path = Slug.of(path);
    return `/imovel/${productCard.sku}/${path}`;
  }

  private mapCondominiumName(name: string) {
    return name ? name : 'lopes';
  }

  private mapAddress(locationDTO: LocationDTO) {
    if (locationDTO) {
      return `${locationDTO.city}-${locationDTO.neighborhood}`;
    }
    return '';
  }

  private mapDealType(productCard: ProductCard) {
    const { dealType, dealTypes } = productCard;
    if (!dealTypes) {
      return this.mapDealTypeByDefault(dealType);
    }
    return this.mapDealTypeByDealTypeList(dealTypes);
  }

  private mapDealTypeByDefault(dealType: DealTypeEnum) {
    if (dealType === DealTypeEnum.Sale) {
      return 'venda';
    }
    return 'aluguel';
  }

  private mapDealTypeByDealTypeList(dealTypes: DealTypeEnum[]) {
    if (dealTypes.includes(DealTypeEnum.Sale)) {
      return 'venda';
    }
    return 'aluguel';
  }

  private mapProductCharacteristics(attributes: ProductAttribute[]) {
    const rooms = attributes.filter(a => a.type === AttributeIcon.Rooms);
    const parkingSpots = attributes.filter(a => a.type === AttributeIcon.ParkingLots);
    const area = attributes.filter(a => a.type === AttributeIcon.Area);
    if (rooms.length > 0) {
      const roomsNumber = Number(rooms[0].value);
      return roomsNumber > 1 ? roomsNumber  + '-quartos-' : roomsNumber  + '-quarto-';
    }
    if (parkingSpots.length > 0) {
      const parkingSpotsNumber = Number(parkingSpots[0].value);
      return parkingSpotsNumber > 1 ? parkingSpotsNumber  + '-vagas-' : parkingSpotsNumber  + '-vaga-';
    }
    if (area.length > 0) {
      return area[0].value.replace(/\D/g, '')  + '-m2-';
    }
    return '';
  }
}
